<template>
  <div>
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span class="heading-primary--main">Blog</span>
        </h1>
      </div>
    </section>
    <div class="row" style="margin-bottom: 4rem">
      <div class="col-2-of-3 underline borderbottom" style="margin-right: 0">
        The latest blog posts
      </div>
      <div
        class="col-1-of-3 borderbottom"
        style="width: 39rem; text-align: right"
      >
        <a href="" class="blog-card-href__link">View all Blog posts</a>
      </div>
    </div>
    <section class="section-blog-card">
      <div v-for="(row, index1) in rows" :key="index1" class="row">
        <div
          v-for="(col, value) in row"
          :key="value"
          :class="`col-1-of-${row.length}`"
        >
          <BlogCard
            :title="col.data.title | truncate(30, '...')"
            :slug="col.data.slug_name"
            :content="col.data.body | truncate(30, '...')"
            :datecreated="col.data.date_edited.seconds"
            :background-image="col.data.coverImage"
            :tags="
              blog_tags[getIndex(col.id)]
                ? blog_tags[getIndex(col.id)][0].tag
                : ''
            "
          />
        </div>
      </div>
    </section>
    <div class="row" style="margin-bottom: 4rem">
      <div class="col-2-of-3 underline borderbottom" style="margin-right: 0">
        The latest Projects
      </div>
      <div
        class="col-1-of-3 borderbottom"
        style="width: 39rem; text-align: right"
      >
        <a href="/blog/tag/Project" class="blog-card-href__link"
          >View all projects</a
        >
      </div>
    </div>
    <section class="section-blog-large">
      <div v-for="(col, index1) in projects" :key="index1" class="row">
        <BlogCardLarge
          :title="col.data.title | truncate(30, '...')"
          :slug="col.data.slug_name"
          :content="col.data.body | truncate(30, '...')"
          :background-image="col.data.coverImage"
          :author="col.data.author"
          :datecreated="col.data.date_edited.seconds"
          :tags="
            project_tags[getPIndex(col.id)]
              ? project_tags[getPIndex(col.id)]
              : ''
          "
        />
      </div>
    </section>
  </div>
</template>

<script>
import BlogCard from '@/components/shared/BlogCard'
import BlogCardLarge from '@/components/shared/BlogCardLarge'
import _ from 'lodash'
import {
  getFirebaseCollectionWhereDual,
  getPostTags
} from '@/functions/firebase/base'
export default {
  name: 'Blog',
  components: {
    BlogCard,
    BlogCardLarge
  },

  metaInfo() {
    return {
      title: 'Blog',
      titleTemplate: '%s | Aaron Fletcher',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'A blog containing thoughts, experiences and experiments of Aaron fletcher with Artificial intelligence in veterinary medicine.'
        }
      ]
    }
  },

  data() {
    return {
      blogs: [],
      blog_tags: [],
      split: '2,3',
      dataLoaded: null,
      search: '',
      blogs_ids: null,
      asecending: [],
      projects: [],
      project_tags: []
    }
  },

  computed: {
    rows() {
      const { split, blogs } = this
      const ret = []
      let si = 0
      let ci = 0
      const splitArr = split.split(',')
      this.blogs.forEach((item) => {
        if (!ret[si]) {
          ret.push([])
        }
        ret[si][ci] = item
        ci = ci + 1
        if (ci >= splitArr[si % splitArr.length]) {
          ci = 0
          si++
        }
      })
      return ret
    }
  },
  mounted() {
    Promise.all([this.getAllBlogs()])
  },
  methods: {
    filterByValue(array, string) {
      return array.filter((o) =>
        Object.keys(o).some((k) =>
          o[k].toLowerCase().includes(string.toLowerCase())
        )
      )
    },
    getIndex(id) {
      for (var i = 0; i < this.blogs.length; i++) {
        if (this.blogs[i].id === id) {
          return i
        }
      }
    },
    getPIndex(id) {
      for (var i = 0; i < this.projects.length; i++) {
        if (this.projects[i].id === id) {
          return i
        }
      }
    },
    async getAllBlogs() {
      //Get all blogs
      getFirebaseCollectionWhereDual(
        process.env.VUE_APP_DB_BLOGS,
        'published',
        true,
        'project',
        false
      ).then((result) => {
        this.blogs = result
        this.blogs.forEach((element) => {
          getPostTags(element.id).then((tags) => {
            if (tags.length > 0) {
              this.blog_tags.push(tags)
            } else {
              this.blog_tags.push(['empty'])
            }
          })
        })
      })

      //get all projects
      getFirebaseCollectionWhereDual(
        process.env.VUE_APP_DB_BLOGS,
        'published',
        true,
        'project',
        true
      ).then((result) => {
        console.log(result)
        this.projects = result

        this.projects.forEach((element) => {
          getPostTags(element.id).then((tags) => {
            console.log(tags)
            if (tags.length > 0) {
              this.project_tags.push(tags)
            } else {
              this.project_tags.push(['empty'])
            }
          })
        })
      })
    },
    chunkArray(array, size) {
      const result = []
      for (let i = 0; i < array.length; i += size) {
        const chunk = array.slice(i, i + size)
        result.push(chunk)
      }
      return result
    }
  }
}
</script>
